import React, { useEffect, useState } from 'react';
import { GameProvider, useGame } from './context/GameContext';
import { GameControls } from './components/GameControls';
import { GameCard } from './components/GameCard';
import { ScoreBoard } from './components/ScoreBoard';
import { GameResults } from './components/GameResults';
import { GameType, MuscleData } from './types';
import muscleDataJson from './all_body_muscles.json';
import './App.css';

const GameApp: React.FC = () => {
  const { state, dispatch } = useGame();
  const [selectedAnswer, setSelectedAnswer] = useState<string>('');
  const [showResult, setShowResult] = useState(false);

  useEffect(() => {
    // JSONデータを読み込み
    dispatch({ type: 'SET_MUSCLE_DATA', payload: muscleDataJson as MuscleData });
  }, [dispatch]);

  const handleStartGame = (gameType: GameType, cheatMode: boolean = false) => {
    dispatch({ type: 'START_GAME', payload: { gameType, cheatMode } });
    setSelectedAnswer('');
    setShowResult(false);
  };

  const handleAnswer = (answer: string) => {
    if (!state.currentSession) return;
    
    setSelectedAnswer(answer);
    setShowResult(true);
    
    const currentQuestion = state.currentSession.questions[state.currentSession.currentQuestionIndex];
    dispatch({
      type: 'ANSWER_QUESTION',
      payload: {
        questionId: currentQuestion.id,
        selectedAnswer: answer
      }
    });
    
    // 2秒後に次の問題へ
    setTimeout(() => {
      const currentSession = state.currentSession;
      if (currentSession && currentSession.currentQuestionIndex + 1 >= currentSession.questions.length) {
        dispatch({ type: 'END_GAME' });
      } else {
        // 次の問題に進む前に状態をクリア
        setSelectedAnswer('');
        setShowResult(false);
      }
    }, 2000);
  };

  const handleResetGame = () => {
    dispatch({ type: 'RESET_GAME' });
    setSelectedAnswer('');
    setShowResult(false);
  };

  const handlePlayAgain = () => {
    if (state.currentSession) {
      handleStartGame(state.currentSession.type, state.currentSession.cheatMode);
    }
  };

  const isGameActive = state.currentSession && !state.currentSession.endTime;
  const isGameComplete = state.currentSession && state.currentSession.endTime;
  const currentQuestion = state.currentSession?.questions[state.currentSession.currentQuestionIndex];

  return (
    <div className="app">
      <GameControls
        onStartGame={handleStartGame}
        onResetGame={handleResetGame}
        isGameActive={!!isGameActive}
      />
      
      {isGameActive && (
        <>
          <ScoreBoard session={state.currentSession!} />
          {currentQuestion && (
            <GameCard
              question={currentQuestion}
              onAnswer={handleAnswer}
              selectedAnswer={selectedAnswer}
              showResult={showResult}
              cheatMode={state.currentSession!.cheatMode}
            />
          )}
        </>
      )}
      
      {isGameComplete && (
        <GameResults
          session={state.currentSession!}
          onPlayAgain={handlePlayAgain}
          onNewGame={handleStartGame}
        />
      )}
    </div>
  );
};

const App: React.FC = () => {
  return (
    <GameProvider>
      <GameApp />
    </GameProvider>
  );
};

export default App;